import { render } from "./NewProForma.vue?vue&type=template&id=e7321b66&scoped=true"
import script from "./NewProForma.vue?vue&type=script&lang=js"
export * from "./NewProForma.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Ltd24ore-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7321b66"]])

export default __exports__